import "./App.css";
import Routes from "./router/router";
import ToastNotification from "./components/Toast";
import { useEffect, useState, useCallback } from "react";
import { useDispatch } from "react-redux";
import { LanguageProvider } from "./context/LanguageContext";
import { initGlobalSocket, disconnectGlobalSocket } from "./services/socket";
import LinkoLogo from "./assets/images/logo/linkologo.png";

// Preload the Linko logo so it is immediately cached in memory and renders without flicker
if (typeof window !== "undefined") {
  const preloadedLogo = new Image();
  preloadedLogo.src = LinkoLogo;
}

function App() {
  const [isLogin, setIsLogin] = useState(null);
  const dispatch = useDispatch();

  const syncAuth = useCallback(() => {
    const user = localStorage.getItem("linko_web");
    if (user) {
      setIsLogin(true);
      // Connect global socket when authenticated (listens to token-status event in real time)
      initGlobalSocket(dispatch);
    } else {
      setIsLogin(false);
      disconnectGlobalSocket(dispatch);
    }
  }, [dispatch]);

  useEffect(() => {
    syncAuth();

    const handleAuthChange = () => {
      syncAuth();
    };

    window.addEventListener("authChanged", handleAuthChange);
    window.addEventListener("storage", handleAuthChange);

    return () => {
      window.removeEventListener("authChanged", handleAuthChange);
      window.removeEventListener("storage", handleAuthChange);
    };
  }, [syncAuth]);

  return (
    <LanguageProvider>
      <ToastNotification />
      <Routes isLogin={isLogin} />
    </LanguageProvider>
  );
}

export default App;

